"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _line = _interopRequireDefault(require("./line"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _propTypes.default.shape({
  id: _propTypes.default.number,
  group: _propTypes.default.string,
  position: _propTypes.default.string,
  startYear: _propTypes.default.string,
  endYear: _propTypes.default.string,
  startMonth: _propTypes.default.string,
  endMonth: _propTypes.default.string,
  city: _propTypes.default.string,
  countryCity: _propTypes.default.string,
  international: _propTypes.default.number,
  cityName: _propTypes.default.string,
  country: _propTypes.default.string,
  countryName: _propTypes.default.string,
  state: _propTypes.default.string,
  stateName: _propTypes.default.string,
  switch: _propTypes.default.number,
  activeLines: _propTypes.default.number,
  organizationalCategories: _propTypes.default.arrayOf(_propTypes.default.string),
  isHighlighted: _propTypes.default.number,
  lines: _propTypes.default.arrayOf(_line.default)
});
exports.default = _default;